export default __webpack_public_path__ + "static/media/DashboardSchedule.3fb12150.png";